import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Button, FormControl, InputGroup, InputLeftAddon, Input, FormLabel } from '@chakra-ui/react';
import { moneyAtom, devMenuOpenAtom } from '../store/game';
import { useUpdateAtom } from 'jotai/utils'
import { useAtom } from 'jotai';


function DevModal() {

  const [isOpen, setOpen] = useAtom(devMenuOpenAtom)

  const onClose = () => setOpen(false)
  const setMoney = useUpdateAtom(moneyAtom)
  
  const onSave = () => {
    
    // update balance
    const newBalance = (document.getElementById('balance') as HTMLInputElement)?.value
    setMoney(newBalance ? parseFloat(newBalance) : 0)
    

    onClose()
  }

  return <Modal isOpen={isOpen} onClose={onClose}>
  <ModalOverlay />
  <ModalContent>
    <ModalHeader>Dev</ModalHeader>
    <ModalCloseButton />
    <ModalBody>
      <FormControl>
        <FormLabel>Balance</FormLabel>
        <InputGroup>
          <InputLeftAddon children='$' />
          <Input id="balance" type="number" />
        </InputGroup>
      </FormControl>
    </ModalBody>
    <ModalFooter>
      <Button colorScheme="blue" onClick={onSave}>Save</Button>
    </ModalFooter>
  </ModalContent>
</Modal>
}


export default DevModal